import { PickingType } from '@flowmap.gl/core';
import { t } from '@lingui/macro';

export const getTooltipState = info => {
    if (!info || !info.object) {
        return;
    }

    // Additional validation for flow data
    if (info.type === PickingType.FLOW && (!info.origin || !info.dest)) {
        console.warn('Flow tooltip data is incomplete:', info);
        return;
    }

    switch (info.type) {
        case PickingType.LOCATION:
            return {
                info,
                position: { left: info.x, top: info.y },
                content: (
                    <>
                        <div>
                            <strong>
                                {info.object?.name || info.object?.id || 'Unknown'}
                            </strong>
                        </div>
                        <div>
                            {t`Входящие поездки`}
                            {': '}
                            {info.totalIn || 0}
                        </div>
                        <div>
                            {t`Исходящие поездки`}
                            {': '}
                            {info.totalOut || 0}
                        </div>
                        <div>
                            {t`Внутренние и круговые поездки`}
                            {': '}
                            {info.totalWithin || 0}
                        </div>
                    </>
                ),
            };
        case PickingType.FLOW:
            return {
                info,
                position: { left: info.x, top: info.y },
                content: (
                    <>
                        <div>
                            {info.origin?.name || info.origin?.id || 'Unknown'}
                            {' → '}
                            {info.dest?.name || info.dest?.id || 'Unknown'}
                        </div>
                        <div>
                            {t`Количество поездок`}
                            {': '}
                            {info.object?.count || 0}
                        </div>
                    </>
                ),
            };
        default: return null;
    }
};
